export default [
  'yuck',
  'oh',
  'phooey',
  'blah',
  'boo',
  'whoa',
  'yowza',
  'huzzah',
  'boo hoo',
  'fooey',
  'geez',
  'pfft',
  'ew',
  'ah',
  'yum',
  'brr',
  'hm',
  'yahoo',
  'aha',
  'woot',
  'drat',
  'gah',
  'meh',
  'psst',
  'aw',
  'ugh',
  'yippee',
  'eek',
  'gee',
  'bah',
  'gadzooks',
  'duh',
  'ha',
  'mmm',
  'tsk tsk',
  'ouch',
  'phew',
  'ack',
  'uh-huh',
  'gosh',
  'hmph',
  'pish',
  'zowie',
  'er',
  'ick',
  'oof',
  'um',
]
